import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters, tabs } from "./config";

const WigOrderList = () => {

  return (
    <Table tableId="wig_orders" title="Wig Order" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-created_at" idKey="wig_order_id" fieldsToSearch={["Name", "Email", "Phone"]} tabs={tabs} tabField="order_type" defaultTab="regular" edit={false} exportCsv={true} additionalCollections="c:full_name" />
  );
};

export default WigOrderList;